module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/directdebit-3bda4f633c31396b2375c726a51c9bb7.png";